export default __webpack_public_path__ + "static/Camera-f8fb8f68c0d04a104fb86b2cdb65827b.png";